<template>
  <form-container>
    <template v-slot:content>
      <h3 class="mb-5 black--text title text-uppercase font-weight-black">Create account</h3>
      <div>
        <v-btn depressed x-large color="deep-orange darken-1" dark block class="mb-2">
          SignUp with Google
          <v-icon right dark>mdi-google</v-icon>
        </v-btn>
        <v-btn depressed x-large color="grey darken-4" dark block>
          SignUp with Github
          <v-icon right dark>mdi-github-circle</v-icon>
        </v-btn>
      </div>

    <div class="overline my-6">or</div>
      <register-form></register-form>
    </template>
  </form-container>
</template>

<script>
import FormContainer from '@/components/FormContainer.vue';
import RegisterForm from '@/components/RegisterForm.vue';

export default {
  name: 'register-page',
  components: {
    FormContainer,
    RegisterForm,
  },
};
</script>
